export const ACCORDION_PARTS = [
  'container',
  'button',
  'panel',
  'icon',
] as const;
